const CONFIGURATION = {
    defaultTheme: 'dpasa-dark',
    authorizedDomains: ['kalkai.ch'],
    apps: {
        dpasa: {
            enabled: true,
            url: 'https://app.kalkai.ch',
        },
        mipasa: {
            enabled: false,
        },
        unbounded: {
            enabled: false,
        },
        papillon: {
            enabled: false,
        },
        crypto: {
            enabled: false,
        },
        soikie: {
            enabled: false,
        },
    },
    oidc: {
        github: false,
        google: false,
        ethereum: true,
    },
    sentry: {
        enabled: false,
    },
};
export default CONFIGURATION;
